var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechStackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 20,
    fill: "#E99F42"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3337 24.9501V14.8917C28.3337 13.8917 27.517 13.1501 26.5253 13.2334H26.4753C24.7253 13.3834 22.067 14.2751 20.5837 15.2084L20.442 15.3001C20.2003 15.4501 19.8003 15.4501 19.5587 15.3001L19.3503 15.1751C17.867 14.2501 15.217 13.3667 13.467 13.2251C12.4753 13.1417 11.667 13.8917 11.667 14.8834V24.9501C11.667 25.7501 12.317 26.5001 13.117 26.6001L13.3587 26.6334C15.167 26.8751 17.9587 27.7917 19.5587 28.6667L19.592 28.6834C19.817 28.8084 20.1753 28.8084 20.392 28.6834C21.992 27.8001 24.792 26.8751 26.6087 26.6334L26.8837 26.6001C27.6837 26.5001 28.3337 25.7501 28.3337 24.9501Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.5742V28.0742",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.458 18.0742H14.583",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.083 20.5742H14.583",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechStackIcon);
export default __webpack_public_path__ + "static/media/techStack_icon.c9964d44f89f210bbdf37600d59a674d.svg";
export { ForwardRef as ReactComponent };